/* eslint react/prop-types: 0 */
import React from 'react';
import { toLocale } from '../../../helpers/numberHelper';

// Custom label renderer: shows the text (children) inside the segment in white
export const LabelInsideSegment = ({
    innerRadius, outerRadius, cx, cy, midAngle, children,
}) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + ((outerRadius - innerRadius) * 0.5);
    const x = cx + (radius * Math.cos(-midAngle * RADIAN));
    const y = cy + (radius * Math.sin(-midAngle * RADIAN));

    return (
        <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" style={{ fontSize: '10px' }}>
            {children}
        </text>
    );
};

// Label Formatter: shows the percent inside the segment
export function renderPercentInSegment(props) {
    return (
        <LabelInsideSegment {...props}>
            {`${(props.percent * 100).toFixed(0)}%`}
        </LabelInsideSegment>
    );
}

// Label Formatter: shows the value inside the segment
export function renderValueInSegment(props) {
    return (
        <LabelInsideSegment {...props}>
            {toLocale(props.value)}
        </LabelInsideSegment>
    );
}
